const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export interface Storage {
  id: string;
  storageName: string;
  storageType: "Yard" | "Self Storage" | "Warehouse" | "Container";
  telephoneNo: string;
  facilityType: "Ware House" | "Container Yard" | "Self Storage";
  postCode: string;
  fullAddress: string;
  locationId: string;
  floors: number;
  unitsInEachFloor: number;
  rowsInEachFloor: number;
  baysInARow: number;
  totalUnits: number;
  availableUnits: number;
  completedUnits: number;
  units: StorageUnit[];
}

export interface StorageUnit {
  id: string;
  refNo: string;
  floorNumber: number;
  size: string;
  type: "Small Container" | "Rack" | "Large Container" | "Pallet";
  price: number;
  duration: "Monthly" | "Quarterly" | "Yearly" | "Weekly";
  customerName?: string;
  description: string;
  isAvailable: boolean;
  assignedDate?: string;
}
export const siteType = ["Yard", "Self Storage", "Warehouse"];
export const storageTypes = [
  "Room",
  "Crate",
  "Pallet",
  "Shelves",
  "Containers",
] as const;

export const facilityTypes = [
  "Ware House",
  "Container Yard",
  "Self Storage",
] as const;

export const unitTypes = [
  "Small Container",
  "Rack",
  "Large Container",
  "Pallet",
  "Shelves",
] as const;

export const durationOptions = [
  "Weekly",
  "Monthly",
  "Quarterly",
  "Yearly",
] as const;

export const storageTableHeadings = [
  { label: "Storage Name", field: "storageName", sortable: true },
  { label: "Storage Type", field: "storageType", sortable: true },
  { label: "Units", field: "units", sortable: false },
];

export const unitTableHeadings = [
  { label: "Ref no.", field: "refNo", width: "100px" },
  { label: "Size & Type", field: "sizeType", width: "180px" },
  { label: "Price & Duration", field: "priceDuration", width: "150px" },
  { label: "Customer name", field: "customerName", width: "200px" },
  { label: "Description", field: "description", width: "250px" },
  { label: "Actions", field: "actions", width: "80px" },
];

export const SITE_FIELDS = [
  {
    id: "siteName",
    label: "Site Name",
    type: "text",
    isRequired: true,
    placeholder: "Enter site name",
    md: 4,
  },
  {
    id: "address",
    label: "Address",
    placeHolder: "Enter street",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 300,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 8,
  },
  {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter postcode",
    type: "text",
    inputProps: {
      maxLength: 8,
    },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "status",
    label: "Status",
    type: "select",
    // required: true,
    options: ["Active", "InActive"],
    md: 4,
  },
  {
    id: "siteType",
    label: "Type Of Site",
    type: "select",
    isRequired: true,
    options: [...siteType],
    md: 4,
  },
  {
    id: "phone",
    label: "Telephone Number",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 4,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "numberOfUnits",
    label: "Number Of Units",
    type: "number",
    required: false,
    placeholder: "",
    min: 1,
    md: 4,
  },

  // --- Floors & Layout Mapping (Aisle -> Row -> Bay) ---
  {
    id: "numberOfFloors",
    label: "Number of Floors",
    type: "number",
    isRequired: true,
    placeholder: "",
    min: 1,
    max: 10,
    md: 3,
  },
  {
    id: "numberOfAisles",
    label: "Number of Aisles",
    type: "number",
    isRequired: true,
    placeholder: "",
    min: 1,
    helperText: "Main walking/driving paths per floor",
    md: 3,
  },
  {
    id: "numberOfRowsPerAisle",
    label: "Rows per Aisle",
    type: "number",
    isRequired: true,
    placeholder: "",
    min: 1,
    defaultValue: 2,
    helperText: "Usually 2 — left row and right row facing the aisle",
    md: 3,
  },
  {
    id: "numberOfBaysPerRow",
    label: "Bays per Row",
    type: "number",
    isRequired: true,
    placeholder: "",
    min: 1,
    helperText: "Vertical rack columns running down the length of each row",
    md: 3,
  },
];
export const STORAGE_FIELDS = [
  {
    id: "siteName",
    label: "Site Name",
    type: "text",
    required: true,
    placeholder: "Enter site name",
    md: 4,
  },

  // {
  //   id: "storage_type",
  //   label: "Storage Type",
  //   type: "select",
  //   required: true,
  //   options: [...storageTypes],
  //   md: 4,
  // },
 
   {
    id: "numberOfBaysInEachFloor",
    label: "Number of bays in each floor",
    type: "number",
    required: false,
    placeholder: "",
    min: 1,
    md: 3,
  },
  {
    id: "numberOfRacks",
    label: "Number of Racks",
    type: "number",
    required: false,
    placeholder: "",
    min: 1,
    md: 3,
  },
  {
    id: "numberOfRowsPerBay",
    label: "Number of Rows per bays",
    type: "number",
    required: false,
    placeholder: "",
    min: 1,
    md: 3,
  },
   {
    id: "numberOfFloors",
    label: "No. of Floors",
    type: "number",
    required: false,
    placeholder: "",
    min: 1,
    max: 10,
    md: 3,
  },
   {
    id: "siteType",
    label: "Site Type",
    type: "select",
    required: true,
    options: [...siteType],
    md: 4,
  },
];

export const STORAGE_FILTER = [
  {
    id: "site_type",
    label: "Site Type",
    type: "select",
    required: true,
    options: [...siteType],
    md: 4,
  },
  {
    id: "storage_type",
    label: "Storage Type",
    type: "select",
    required: true,
    options: [...storageTypes],
    md: 4,
  },
];

export const initialStorageFormData = {
  storageName: "",
  storageType: "",
  facilityType: "",
  telephoneNo: "",
  postCode: "",
  fullAddress: "",
  locationId: "",
  floors: "",
  unitsInEachFloor: "",
  rowsInEachFloor: "",
  baysInARow: "",
};

export const FORM_ELEMENT_FIELDS = [
  // ---------- Unit Details (left column) ----------
  {
    id: "type_name",
    label: "Type Name",
    placeHolder: "",
    type: "text",
    md: 12,
    section: "unitDetails",
    inputProps: { maxLength: 50 },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "storage_type",
    label: "Storage Type",
    placeHolder: "Select",
    type: "select",
    options: ["Room", "Crate", "Pallet", "Shelves", "Containers"],
    md: 12,
    section: "unitDetails",
    isRequired: true,
  },
  {
    id: "size",
    label: "Size (ft³)",
    placeHolder: "Enter size",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 12,
    section: "unitDetails",
  },
  {
    id: "quantity",
    label: "Quantity",
    placeHolder: "Enter quantity",
    type: "text",
    patternAllowed: patternConstant?.NUMERIC, // numeric only
    isRequired: true,
    md: 12,
    section: "unitDetails",
  },
  {
    id: "unitNumbering",
    label: "Unit Numbering / Ref No.",
    placeHolder: "Select",
    type: "select",
    options: ["Sequential Numbering"],
    md: 6,
    section: "unitDetails",
    isRequired: true,
  },
  {
    id: "prefix",
    label: "Prefix (Max. 5 letters)",
    placeHolder: "e.g. RM001",
    type: "text",
    inputProps: { maxLength: 5 },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    md: 6,
    section: "unitDetails",
  },
  {
    id: "price_per_unit",
    label: "Price Per Unit",
    placeHolder: "0.00",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 6,
    section: "unitDetails",
    // combine with a rent-frequency dropdown (Month/Week) next to it if needed
  },
  {
    id: "price_frequency",
    label: "Frequency",
    type: "select",
    options: ["Month", "Week", "Day"],
    md: 6,
    section: "unitDetails",
  },

  // ---------- Dimensions (right column, top) ----------
  {
    id: "width",
    label: "Width (ft)",
    placeHolder: "Enter width",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 6,
    section: "dimensions",
  },
  {
    id: "length",
    label: "Length (ft)",
    placeHolder: "Enter length",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 6,
    section: "dimensions",
  },
  {
    id: "height",
    label: "Height (ft)",
    placeHolder: "Enter height",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 6,
    section: "dimensions",
  },

  // ---------- Rent and Unit Costs (right column, bottom) ----------
  {
    id: "monthly_rent",
    label: "Monthly Rent",
    placeHolder: "0.00",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    md: 12,
    section: "rentCosts",
  },
  {
    id: "weekly_rent",
    label: "Weekly Rent",
    placeHolder: "0.00",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    md: 12,
    section: "rentCosts",
  },
  {
    id: "utility_charges",
    label: "Utility Charges (Monthly)",
    placeHolder: "0.00",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    md: 12,
    section: "rentCosts",
  },
];

export const ADD_UNIT_FIELDS = [
  {
    id: "size",
    label: "Storage Size",
    type: "text",
    required: true,
    placeholder: "e.g., 24 Sq.",
    md: 3,
  },
  {
    id: "type",
    label: "Type",
    type: "select",
    required: true,
    options: [...unitTypes],
    md: 3,
  },
  {
    id: "totalQuantity",
    label: "Total Quantity",
    type: "number",
    required: true,
    placeholder: "e.g., 7",
    min: 1,
    md: 3,
  },
  {
    id: "price",
    label: "Price (₹)",
    type: "number",
    required: true,
    placeholder: "e.g., 5000",
    min: 0,
    md: 3,
  },
  {
    id: "duration",
    label: "Duration",
    type: "select",
    required: true,
    options: [...durationOptions],
    md: 3,
  },
];

export const ADD_UNIT_EXTRA_FIELDS = [
  {
    id: "prefix",
    label: "Prefix",
    type: "text",
    required: false,
    placeholder: "e.g., SH",
    md: 3,
  },
  {
    id: "startingNo",
    label: "Starting no.",
    type: "number",
    required: false,
    placeholder: "e.g., 1",
    min: 1,
    md: 3,
  },
];

export const ADD_UNIT_DESC_FIELD = {
  id: "description",
  label: "Description",
  type: "textarea",
  required: false,
  placeholder: "Please Enter Description",
  md: 12,
  minRows: 2,
  maxRows: 4,
};

export const initialUnitFormData = {
  size: "",
  type: "",
  totalQuantity: "",
  price: "",
  duration: "",
  prefix: "",
  startingNo: "",
  description: "",
};

export const assignUnitFields = [
  {
    id: "customerName",
    label: "Customer Name",
    type: "text",
    required: true,
    placeholder: "Enter customer name",
  },
  {
    id: "assignedDate",
    label: "Assigned Date",
    type: "date",
    required: true,
  },
  {
    id: "notes",
    label: "Notes",
    type: "textarea",
    required: false,
    placeholder: "Additional notes",
    rows: 3,
  },
];

// Mock data for development
export const mockStorages: Storage[] = [
  {
    id: "001",
    storageName: "North Wing Facility",
    storageType: "Yard",
    telephoneNo: "9876543210",
    facilityType: "Container Yard",
    postCode: "PH423",
    fullAddress: "",
    locationId: "NW 01",
    floors: 2,
    unitsInEachFloor: 4,
    rowsInEachFloor: 2,
    baysInARow: 2,
    totalUnits: 15,
    availableUnits: 0,
    completedUnits: 15,
    units: [],
  },
  {
    id: "002",
    storageName: "Warehouse 1",
    storageType: "Self Storage",
    telephoneNo: "9876543210",
    facilityType: "Self Storage",
    postCode: "PH423",
    fullAddress: "",
    locationId: "WH 01",
    floors: 1,
    unitsInEachFloor: 5,
    rowsInEachFloor: 1,
    baysInARow: 5,
    totalUnits: 5,
    availableUnits: 5,
    completedUnits: 0,
    units: [],
  },
  {
    id: "003",
    storageName: "South Block Storage",
    storageType: "Warehouse",
    telephoneNo: "9876543210",
    facilityType: "Ware House",
    postCode: "PH423",
    fullAddress: "",
    locationId: "GW 01",
    floors: 3,
    unitsInEachFloor: 6,
    rowsInEachFloor: 2,
    baysInARow: 2,
    totalUnits: 6,
    availableUnits: 1,
    completedUnits: 0,
    units: [
      {
        id: "unit-001",
        refNo: "GW 01",
        floorNumber: 1,
        size: "200",
        type: "Small Container",
        price: 2000,
        duration: "Monthly",
        customerName: "Global Working",
        description: "When Enter mouse then Hover full description...",
        isAvailable: false,
        assignedDate: "2026-01-15",
      },
      {
        id: "unit-002",
        refNo: "GW 02",
        floorNumber: 1,
        size: "300",
        type: "Rack",
        price: 3000,
        duration: "Quarterly",
        customerName: undefined,
        description: "Unit Description",
        isAvailable: true,
      },
    ],
  },
  {
    id: "004",
    storageName: "Eastern Wing Facility",
    storageType: "Warehouse",
    telephoneNo: "9876543210",
    facilityType: "Ware House",
    postCode: "PH424",
    fullAddress: "",
    locationId: "EW 01",
    floors: 3,
    unitsInEachFloor: 5,
    rowsInEachFloor: 3,
    baysInARow: 3,
    totalUnits: 15,
    availableUnits: 15,
    completedUnits: 0,
    units: [],
  },
];
